export default "__VITE_ASSET__yW_eMvu1QqHghXJHMLbBbg__ 480w, __VITE_ASSET__07gvO1IvTzTCTyYqp_a5mw__ 770w";